require('./bootstrap');
require('magnific-popup');
require('waypoints/lib/jquery.waypoints.min');
// require('swiper/swiper-bundle.min');

import Swiper from 'swiper/swiper-bundle';

function hideBody() {
    $('html, body').css('overflow', 'hidden');
}

function clearBodyStyle() {
    $('html, body').removeAttr('style');
}

$(document).ready(function () {

    new Swiper(".ads__list", {
        slidesPerView: 'auto',
        spaceBetween: 18,
        grabCursor: true,
        breakpoints: {
            360: {
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15
            },
            414: {
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15
            },
            744: {
                slidesOffsetBefore: 30,
                slidesOffsetAfter: 30
            },
            1440: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0
            },
            1920: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0
            }
        }

    });

    new Swiper(".gallery", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        breakpoints: {
            360: {
                spaceBetween: 12,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15
            },
            414: {
                spaceBetween: 12,
                slidesOffsetBefore: 15,
                slidesOffsetAfter: 15
            },
            744: {
                slidesOffsetBefore: 30,
                slidesOffsetAfter: 30
            },
            1440: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0
            },
            1920: {
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0
            }
        }

    });

    $(".hero__img").animate({
        opacity: 1,
    });

    // Появление меню
    // $(window).scroll(function() {
    //     // console.log($(window).scrollTop());
    //     if ($(this).scrollTop() > 650) {
    //         $('.fixed-menu').fadeIn();
    //     } else {
    //         $('.fixed-menu').fadeOut();
    //     }
    // });

    function topSizer() {

        if (window.matchMedia('(max-width: 744px)').matches) {
            return 75;
        }

        return 100;
    }


    $(".page-hero__link").click(function () {

        $('body').addClass('waypoint-hide');

        // window.location.hash = 'section:' + $(this).text();

        $("html, body").animate({

            scrollTop: $($(this).attr("href")).offset().top - topSizer()
        }, {
            duration: 500,
            easing: "swing",
            complete: function () {
                $('body').removeClass('waypoint-hide');
            }
        });

        return false;
    });

    $(document).on('click', '.header__menu', function () {
        hideBody();
        $('.menu').removeClass('menu--hide');
        window.location.hash = 'menu';
    });

    $(document).on('click', '.menu__header-close', function () {
        clearBodyStyle();
        $('.menu').addClass('menu--hide');
        window.location.hash="";
    });

});